import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {Translate} from 'views/module';

const MedicalHistoryBoxView = (props) => {
  const {data} = props;
  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.MedicalHistoryBox.Title" />
        </Typography>
      </Box>
      <Typography variant="subtitle2">
        <Translate expression="profile.MedicalHistoryBox.Conditions" />
      </Typography>
      {
        data.conditions && (
          <ul
            style={{paddingLeft: '2rem', marginTop: '0.5rem', marginBottom: '1rem', fontSize: 15}}
          >
            {data.conditions.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>
        )
      }
      {
        !data.conditions && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', marginTop: '0.5rem', marginBottom: '1rem'}}>
            <Translate expression="profile.MedicalHistoryBox.ConditionsPlaceholder" />
          </Typography>
        )
      }
      <Typography variant="subtitle2">
        <Translate expression="profile.MedicalHistoryBox.Medications" />
      </Typography>
      {
        data.medications && (
          <ul
            style={{paddingLeft: '2rem', marginTop: '0.5rem', marginBottom: 0, fontSize: 15}}
          >
            {data.medications.map((m, i) => (
              <li key={i}>{m}</li>
            ))}
          </ul>
        )
      }
      {
        !data.medications && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', marginTop: '0.5rem', marginBottom: 0}}>
            <Translate expression="profile.MedicalHistoryBox.MedicationsPlaceholder" />
          </Typography>
        )
      }
    </Box>
  );
};

MedicalHistoryBoxView.propTypes = {
  data: PropTypes.shape({
    conditions: PropTypes.arrayOf(PropTypes.string),
    medications: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default MedicalHistoryBoxView;
